import React from 'react';
import PropTypes, { func } from 'prop-types';
import { Button, Checkbox, Input } from 'antd';
import { faSearch } from '@fortawesome/pro-light-svg-icons/faSearch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-light-svg-icons';
import { FormattedNumber } from 'react-intl';
import { textAlign } from 'styled-system';
import { detalleCreacionType } from '../../types/encargo.creacion.types';
import {
  Box, Flex, ShowIf, Text,
} from '../../../shared/components';
import gafasGraduadasSVG from '../../assets/img/Gafas graduadas.svg';
import gafasSolSVG from '../../assets/img/Gafas de sol.svg';
import lentesContactoSVG from '../../assets/img/Lentes de contacto.svg';
import audioSVG from '../../assets/img/Audio.svg';
import otrosArticulosSVG from '../../assets/img/Otros articulos.svg';

export default function LineaArticulo({
  detalle, onSelectLinea, onClickEliminarArticulo, modo,
}) {
  const {
    cadenaTipo, articulo, descripcion, precio, unidades, linea, cdgtipo,
  } = detalle;
  const obtenerImagenPorTipoArticulo = (cdgtipo) => {
    const enteroTipo = parseInt(cdgtipo, 10);
    switch (enteroTipo) {
      case 1:
        break;
      case 2:
        return lentesContactoSVG;
      case 3:
        return gafasGraduadasSVG;
      case 4:
        break;
      case 5:
        return gafasSolSVG;
    }
  };
  return (
    <Flex justifyContent="space-between">
      <Flex>
        <Checkbox style={{ marginRight: '8px' }} onChange={() => onSelectLinea(linea)} />
        <Flex height="110px" width="110px" style={{ border: '1px solid #EBEBEB' }}>
          <Flex justifyContent="center" alignItems="center" m="5px">
            <img alt="ImagenArticulo" src={obtenerImagenPorTipoArticulo(cdgtipo)} style={{ width: '100%' }} />
          </Flex>
        </Flex>
        <Box style={{ textAlign: 'center' }} width="32px" ml="16px">
          <Input style={{ marginBottom: '16px' }} disabled value={unidades} />
          <ShowIf condition={modo !== 'mostrar'}>
            <FontAwesomeIcon color="#898989" style={{ margin: 'auto', width: '18px', height: '20px' }} onClick={() => { onClickEliminarArticulo(); }} icon={faTrash} />
          </ShowIf>
        </Box>
        <Box ml="16px">
          <Box mb="8px"><Text color="#3E3E3C" lineHeight="16px" fontSize="14px">{cadenaTipo}</Text></Box>
          <Box mb="8px"><Text color="#282724" lineHeight="16px" fontSize="16px">{descripcion}</Text></Box>
          <Box mb="8px">
            <Button
              style={{
                margin: '0 16px 0 0', padding: '0 0 0 0', border: '0', height: '16px', pointerEvents: 'none'
              }}
              type="link"
            >
              <Text fontSize="14px" translationId="encargos.numero_lote" />
            </Button>
            <Button
              style={{
                margin: '0 16px 0 0', padding: '0 0 0 0', border: '0', height: '16px', pointerEvents: 'none'
              }}
              type="link"
            >
              <Text fontSize="14px" translationId="encargos.invima" />
            </Button>
          </Box>
        </Box>
      </Flex>
      <Flex flexDirection="column" alignItems="flex-end" ml="16px">
        <div style={{ height: '16px', marginBottom: '8px' }} />
        {/* eslint-disable-next-line react/style-prop-object */}
        <Box mb="8px"><Text color="#3E3E3C" fontSize="16px"><FormattedNumber minimumFractionDigits="2" maximumFractionDigits="2" style="currency" currency="EUR" value={precio} /></Text></Box>
        <Box mb="8px">
          <Button
            style={{
              margin: '0 0 0 0', padding: '0 0 0 0', border: '0', height: '16px', pointerEvents: 'none'
            }}
            type="link"
          >
            <Text fontSize="14px" translationId="encargos.descuento" />
          </Button>
        </Box>
      </Flex>
    </Flex>
  );
}
LineaArticulo.propTypes = {
  detalle: detalleCreacionType.isRequired,
  onClickEliminarArticulo: func.isRequired,
  onSelectLinea: func,
  modo: PropTypes.string.isRequired,
};

LineaArticulo.defaultProps = {
  onSelectLinea: () => {},
};
